import { useEffect, useState } from "react";
import { getUrlAdjuntoChatElite } from "../services/chatElite.service";

/**
 * Cache en memoria de URLs temporales (SAS) de adjuntos. Se renuevan 1 minuto antes de caducar
 * y las peticiones en curso se comparten (varias miniaturas del mismo adjunto = 1 peticion).
 */
const cache = new Map();
const MARGEN_MS = 60 * 1000;

const clave = (ticketId, adjuntoId, opciones) =>
  `${ticketId}:${adjuntoId}:${opciones.miniatura ? "min" : "orig"}:${opciones.descargar ? "dl" : "in"}`;

export const obtenerUrlAdjunto = (ticketId, adjuntoId, opciones = {}) => {
  const k = clave(ticketId, adjuntoId, opciones);
  const entrada = cache.get(k);
  if (entrada?.promesa) return entrada.promesa;
  if (entrada?.url && new Date(entrada.expiraEn).getTime() - MARGEN_MS > Date.now()) return Promise.resolve(entrada.url);

  const promesa = getUrlAdjuntoChatElite(ticketId, adjuntoId, opciones)
    .then(({ url, expiraEn }) => {
      cache.set(k, { url, expiraEn });
      return url;
    })
    .catch((error) => {
      cache.delete(k);
      throw error;
    });
  cache.set(k, { promesa });
  return promesa;
};

/**
 * @returns {{ url: string|null, error: string|null }}
 */
const useUrlAdjuntoChatElite = (ticketId, adjunto, { miniatura = false, activo = true } = {}) => {
  const [estado, setEstado] = useState({ url: null, error: null });
  const adjuntoId = adjunto?.id;
  const eliminado = adjunto?.eliminado;

  useEffect(() => {
    if (!activo || !ticketId || !adjuntoId || eliminado) return undefined;
    let vivo = true;
    obtenerUrlAdjunto(ticketId, adjuntoId, { miniatura })
      .then((url) => vivo && setEstado({ url, error: null }))
      .catch((error) => vivo && setEstado({ url: null, error: error.code || "ERROR" }));
    return () => {
      vivo = false;
    };
  }, [ticketId, adjuntoId, miniatura, activo, eliminado]);

  return estado;
};

export default useUrlAdjuntoChatElite;
